import { render, staticRenderFns } from "./DownloadPanel.vue?vue&type=template&id=560994ce&scoped=true"
import script from "./DownloadPanel.vue?vue&type=script&lang=ts"
export * from "./DownloadPanel.vue?vue&type=script&lang=ts"
import style0 from "./DownloadPanel.vue?vue&type=style&index=0&id=560994ce&prod&lang=less"
import style1 from "./DownloadPanel.vue?vue&type=style&index=1&id=560994ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560994ce",
  null
  
)

export default component.exports